import MainAddress from "../";
import { GetSerialProgram } from "../../util/sessionManager";
import { GetWithExpiry } from "../../util/sessionManager";
import axios from 'axios';

export async function ReadNewCustomer(){
    try{
        const response = await axios.post(
            MainAddress+"NewCustommer/customerData.php",
            {
                serial_program:GetSerialProgram(),
            }
          )
          console.log(response)
        if(response.data[0].success){
            return {
                success:true,
                data:response.data
            }
        }else{
            return {
                success:false,
                message:response
            };
        }
    }catch(error){
        return {
            success:false,
            message:error
        };
    }

}

export async function ReadvisitorNewCustommer(data){
    try{
        const response = await axios.post(
            MainAddress+"NewCustommer/readnewCustomerList.php",
            {
                ...data,
                serial_program:GetSerialProgram(),
            }
          )
          console.log(response)
        if(response.data[0].success){
            return {
                success:true,
                data:response.data
            }
        }else{
            return {
                success:false,
                message:response
            };
        }
    }catch(error){
        return {
            success:false,
            message:error
        };
    }

}